"use client";

import { useQuery } from "@tanstack/react-query";
import { useSnapshot } from "valtio/react";
import { useOspApiClientProvider } from "@hooks/useOspApiClientProvider";
import { rootStore } from "@store/rootStore";
import { fetchPlanDiagnosisGoals } from "./fetchPlanDiagnosisGoals";
import { planQueryKeys } from "./planQueryKeys";

/** Plan 共用诊断列表 — 避免多 observer 在 staleTime=0 时重复打 /goals */
/** Batch 2优化: 延长staleTime从60秒到120秒，提高缓存命中率，减少重复请求 */
const PLAN_DIAGNOSIS_GOALS_STALE_MS = 120_000;

type UsePlanDiagnosisGoalsQueryOptions = {
  enabled?: boolean;
};

/**
 * `GET /goals?status=INACTIVE,PLANNED&sort=PRIORITY&enrich_hash_data=true` — Gate / For You / Checkup 唯一 query 入口。
 */
export function usePlanDiagnosisGoalsQuery(
  options: UsePlanDiagnosisGoalsQueryOptions = {},
) {
  const { isLoggedIn } = useSnapshot(rootStore.login);
  const { ownerInfo } = useSnapshot(rootStore.user);
  const ownerId = ownerInfo?.id;
  const { trackerApi } = useOspApiClientProvider();

  const enabled =
    (options.enabled ?? true) && Boolean(isLoggedIn && ownerId && trackerApi);

  return useQuery({
    queryKey: planQueryKeys.diagnosisGoals(),
    enabled,
    staleTime: PLAN_DIAGNOSIS_GOALS_STALE_MS,
    queryFn: () => fetchPlanDiagnosisGoals(trackerApi),
  });
}
